import {Injectable} from '@angular/core';
import {BackendParam, BackendService} from '@tg4/http-infrastructure/dist/src';
import {Observable} from 'rxjs';
import {ExternalEvaluation} from './_interfaces/external-evaluation';
import {ExternalUserConfig} from './_interfaces/external-user-config';
import {map} from 'rxjs/operators';
import {SharedService} from 'src/app/shared/services/shared.service';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {AuthService} from 'src/app/shared/services/auth.service';
import { ConfigService } from '../shared/services/multi-clients/config.service';


@Injectable({
    providedIn: 'root'
})
export class ExternalEvaluationsService {
    apiUrl: string;

    constructor(private _httpService: BackendService,
                private _sharedService: SharedService,
                private http: HttpClient,
                private _authService: AuthService,
                private _configService: ConfigService
            ) {
              this.apiUrl  = this._configService.settings.apiUrl;
    }

    public getExternalEvaluation(externalUserId: string): Observable<any> {
        return this._httpService.get('getExternalEvaluation', [], [
            {'name': 'externalUserId', 'value': externalUserId as any}
        ]);
    }

    public getAllExternalEvaluations(
        searchString: string = ''
        , page: number = 1
        , pageSize: number = 10
        , orderBy: string = ''
        , orderDirection: string = ''
        , status: any
        , evaluators: any
        , creators: any
        , evaluees: any
    ): Observable<any> {

        let parameters = [
            {'name': 'page', 'value': page as any},
            {'name': 'pageSize', 'value': pageSize as any},
            {'name': 'searchString', 'value': searchString},
            {'name': 'orderBy', 'value': orderBy},
            {'name': 'orderDirection', 'value': orderDirection}
        ];

        this._addArrayToParameters(parameters, 'status', status);
        this._addArrayToParameters(parameters, 'evaluators', evaluators);
        this._addArrayToParameters(parameters, 'creators', creators);
        this._addArrayToParameters(parameters, 'evaluees', evaluees);

        return this._httpService.get('getAllExternalEvaluations', [], parameters);
    }

    private _addArrayToParameters(parameters, name: string, array: any[]) {
        if (array && array.length > 0) {
            parameters.push({ 'name': name, 'value': array.join(',') });
        }
    };

    public searchAttributes(
        type: number,
        limit: boolean,
        onlyActiveAttributes: boolean
    ): Observable<any> {
        const parameters: BackendParam[] = [
            {name: 'type', value: type.toString()},
            {name: 'limit', value: limit.toString()},
            {name: 'onlyActiveAttributes', value: onlyActiveAttributes.toString()},
        ];
        return this._httpService.get('searchExternalEvaluationAttributes', [], parameters);
    }

    public authorizeExternalEvaluation(externalUserId: string): Observable<any> {
        return this._httpService.put('authorizeExternalEvaluation', {
            'externalUserId': externalUserId,
        });
    }

    public resendExternalEvaluation(externalUserId: string): Observable<any> {
        return this._httpService.put('resendExternalEvaluation', {
            'externalUserId': externalUserId,
        });
    }

    public updateExternalEvaluation(evaluation: ExternalEvaluation): Observable<any> {
        return this._httpService.put('updateExternalEvaluation', evaluation);
    }

    public sendExternalEvaluation(evaluation: ExternalEvaluation): Observable<any> {
        return this._httpService.put('sendExternalEvaluation', evaluation);
    }

    public deleteExternalEvaluation(externalUserId: string): Observable<any> {
        return this._httpService.delete('deleteExternalEvaluation', [
            {'name': 'externalUserId', 'value': externalUserId as any}
        ]);
    }

    public reopenExternalEvaluation(externalUserId: string): Observable<any> {
        return this._httpService.post('reopenExternalEvaluation', {
            'externalUserId': externalUserId
        });
    }

    public addExternalUser(externalUser: ExternalUserConfig): Observable<any> {
        return this._httpService.post('addExternalUser', externalUser);
    }

    public updateExternalUser(externalUser: ExternalUserConfig): Observable<any> {
        return this._httpService.put('updateExternalUser', externalUser);
    }

    public downloadExternalEvaluationReport(): Observable<any> {
        const applicationsUrl = `${this.apiUrl}/api/externalEvaluation/getReport`;
        const user = this._authService.getLoggedUser();
        const options = {

            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': user.access_token,
                'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            }),
            observe: 'response' as 'body',
            responseType: 'blob' as 'json'
        };
        return this.http.get(applicationsUrl, options)
            .pipe(map((res) => this._sharedService.downloadFile(res)));
        //
    }

}
